export default __webpack_public_path__ + "static/banner_dubai-5871cce49106f803a12b5becc50483e5.webp";